import { ArrowDownward } from "@mui/icons-material";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { commonTableStyles as styles } from "../styles";
import { ReducersModal } from "utils/modals";
import { UPDATE_CARS_TYPE_REDUCER } from "store/actionTypes";
import ContainedButton from "components/button/contained-button";
import AddCarTypes from "modules/utilityManagement/addCarType";
import { getCarTypesListing } from "modules/utilityManagement/action";
import Loader from "components/loader";
import "../style.css";

const CarsTable = () => {
  const { result, pagination, loader } = useSelector(
    (state: ReducersModal) => state.CarsTypeReducer
  );
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatchValue({ loader: true });
    dispatch(getCarTypesListing());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [isSort, setIsSort] = useState<{ [key: string]: boolean }>({
    createdAt: false,
    city: false,
    firstName: false,
    email: false,
  });

  const dispatchValue = (payload: any) => {
    dispatch({
      type: UPDATE_CARS_TYPE_REDUCER,
      payload,
    });
  };

  const handleSort = (sortCol: string) => {
    const newObject: any = {};
    Object.keys(isSort).forEach(function sort(key) {
      if (key === sortCol) {
        newObject[key] = !isSort[key];
      } else {
        newObject[key] = false;
      }
    });
    setIsSort(newObject);
    dispatchValue({
      page: 1,
      sortedBy: sortCol,
      sortOrder: newObject[sortCol] ? "1" : "-1",
    });

    dispatch(getCarTypesListing());
  };

  const handleChangePage = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    dispatchValue({ page: newPage + 1 });
    dispatch(getCarTypesListing());
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    dispatchValue({ limit: event.target.value, page: 1 });
    dispatch(getCarTypesListing());
  };
  const [open, setOpen] = useState(false);

  const renderLoading = () => {
    return (
      <React.Fragment>
        <Box sx={styles.searchAndFilter}>
          <Skeleton
            height={48}
            width={300}
            variant="rectangular"
            sx={{ borderRadius: "12px" }}
          />
        </Box>
        <Skeleton
          height={500}
          width={"100%"}
          variant="rectangular"
          sx={{ borderRadius: "8px", marginTop: "16px" }}
        />
      </React.Fragment>
    );
  };
  const renderView = () => {
    if (loader && result.length === 0) {
      return renderLoading();
    }
    return (
      <>
        <Box sx={styles.buttonBox}>
          <ContainedButton
            externalStyles={styles.HeadBtns}
            onClick={() => {
              setOpen(true);
            }}
            title={"Add Car Type"}
          />
          <AddCarTypes state={open} setState={setOpen} />
        </Box>
        <Box sx={styles.paper}>
          <TableContainer>
            <Table sx={styles.table}>
              <TableHead sx={{ ...styles.tableHeader }}>
                <TableRow sx={styles.headerRow}>
                  <TableCell sx={styles.headingTitleText}>{"S.No."}</TableCell>
                  <TableCell sx={styles.headingTitleText}>{"Car Type"}</TableCell>
                  <TableCell sx={styles.headingTitleText}>
                    {"Created On"}
                    <ArrowDownward
                      sx={{
                        ...styles.dwnIcnStyl,
                        ...(isSort["createdAt"] && { ...styles.rotateIcon }),
                      }}
                      onClick={() => handleSort("createdAt")}
                    />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {result && result.length > 0 ? (
                  result.map((val: any, index) => {
                    let serialNumber = index + 1;

                    return (
                      <TableRow key={val.id} sx={{ ...styles.row }}>
                        <TableCell>{serialNumber}</TableCell>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          {val?.carType}
                        </TableCell>
                        <TableCell>
                          {val?.createdAt
                            ? moment(val.createdAt).format("DD/MM/YYYY")
                            : "N/A"}
                        </TableCell>
                        {/* <TableCell>
                                            <Box sx={styles.action_table_cell_container}>
                                                <Button
                                                className='action-view-btn'
                                                onClick={() => onEditClick(val)}>
                                                {'Edit'}
                                            </Button>
                                            </Box>
                                        </TableCell> */}
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell colSpan={15} sx={styles.noDataCell}>
                      <Box>{"No Data Found"}</Box>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {showBlockPopup && <BlockClientPopup />} */}

          <Box sx={styles.paginationContainer}>
            <TablePagination
              component="div"
              count={pagination.totalRecords}
              page={pagination?.page - 1}
              onPageChange={handleChangePage}
              rowsPerPage={pagination?.limit}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        </Box>
      </>
    );
  };

  return (
    <Box>
      {renderView()}
      {loader && (result.length > 0 || result.length === 0) && <Loader />}
    </Box>
  );
};

export default CarsTable;
